// extracted by mini-css-extract-plugin
module.exports = {"about":"about-module--about--1Jltn","aboutContent":"about-module--about-content--3hr8g","aboutContentItem":"about-module--about-content-item--1B8L9"};